<template>
  <div>
    <Button size="large" type="text" @click="backHome">返回首页</Button>
    <Button size="large" type="text" @click="backPrev">返回上一页({{ second }}s)</Button>
  </div>
</template>

<script>
import './error.less'
export default {
  name: 'backBtnGroup',
  data () {
    return {
      second: 5,
      tabList:[],
      selectMenuItem:{},
      timer: null
    }
  },
  methods: {
    backHome () {
      this.$router.replace({
        name: 'home'
      })
    },
    backPrev () {
      this.$router.go(-1)
    },
    reduceMenu() {
      this.tabList.splice(index, 1);
      if (this.tabList.length <= 0) {
        setTimeout(() => {
            this.$router.push({ name: 'home' })
        }, 300);
        return
      }
      this.$store.commit("setTabMenuList", this.tabList);

      setTimeout(() => {
          this.$store.commit("setSlideItem", this.tabList[index - 1]);
          this.$router.push({ path: this.tabList[index-1].routerUrl, })
      }, 500);
    },
  },
  created() {
    this.tabList = this.$store.state.tabList;
    this.selectMenuItem = this.$store.state.selectMenuItem;
  },
  mounted () {
    this.timer = setInterval(() => {
      if (this.second === 0) this.backPrev()
      else this.second--
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
